<template>
    <input 
        :id="id"
        :type="type" 
        class="gz-text-input"
        :class="{'gz-text-input_disabled': disabled, 'gz-text-input_select': selectType}"
        :value="imported ? imported : value"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        @input="getValue"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        @keydown="$emit('keydown')"
        @change="$emit('change')"
    >
</template>

<script>
export default {
    name: 'TextInput',

    props: {
        id: {
            type: String
        },
        type: {
            type: String,
            default: 'text'
        },
        importedData: {
            //Данные, которые приходят из вне
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String
        },
        selectType: {
            //Если true значит выпадающий список - курсор pointer
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            value: ''
        }
    },
    computed: {
        imported() {
            return this.importedData
        }
    },
    methods: {
        getValue() {
            this.value = event.target.value
            
            this.$emit('value', this.value)
        }
    },
}
</script>